<template lang="pug">
vm-prompt(@vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" @vm-action="deleteRecordConfirm(form)" :vm-action="form.deleted_at" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="form.deleted_at" :vm-is-valid="!$v.form.$invalid" :vm-active="isModalVisible" :vm-title='getTitle')
  vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12" v-shortcuts="[{ shortcut: [ 'enter', ], callback: saveRecord, push: true, focus: true, disabled: $v.form.$invalid },]")
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        vm-input(autofocus :placeholder='$t("products.name_placeholder")' :danger="$v.form.name.$invalid && $v.form.name.$model" :danger-text="$t('validation.required', { attribute: $t('products.name') })" v-model="form.name" :label='$t("products.name")')
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        vm-input(:placeholder='$t("products.sku_placeholder")' :danger="$v.form.sku.$invalid && $v.form.sku.$model" :danger-text="$t('validation.required', { attribute: $t('products.sku') })" v-model="form.sku" :label='$t("products.sku")')
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        vm-input(:placeholder='$t("products.category_placeholder")' :danger="$v.form.category.$invalid && $v.form.category.$model" :danger-text="$t('validation.required', { attribute: $t('products.category') })" v-model="form.category" :label='$t("products.category")')
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        vm-input(:placeholder='$t("products.unit_price_placeholder")' :danger="$v.form.unit_price.$invalid && $v.form.unit_price.$model" :danger-text="$t('validation.required', { attribute: $t('products.unit_price') })" v-model="form.unit_price" :label='$t("products.unit_price")')
</template>

<script>
import ModalMixin1 from '@/mixins/ModalMixin1'
import { required } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Products')

export default {
  name: 'ModalProducts',
  mixins: [ModalMixin1],
  // data: () => ({}),
  validations () {
    return {
      form: {
        name: {
          required
        },
        sku: {
          required
        },
        category: {
          required
        },
        unit_price: {
          required
        }
      }
    }
  },
  computed: {
    ...mapGetters(['isModalVisible', 'catalog'])
  },
  async created () {
    this.getCatalog()
  },
  methods: {
    ...mapActions([
      'addRecord',
      'editRecord',
      'deleteRecord',
      'setModalVisible',
      'loadCatalog'
    ])
  }
}
</script>
